import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import './assets/style.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import axios from 'axios';

axios.defaults.baseURL = process.env.VUE_APP_API_HOST;
axios.defaults.headers['Content-Type'] = 'application/json';
axios.defaults.withCredentials = true;
const app = createApp(App);

app.use(store);
app.use(router);

app.mount('#app');
store.dispatch('initializeTheme');
